var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crew-position-card"},_vm._l((_vm.positions),function(pos,idx){return _c('div',{key:idx,staticClass:"crew-position-row"},[_c('span',{staticStyle:{"margin-left":"16px"}},[_vm._v(_vm._s(_vm.formatDate(pos.start_at))+"~")]),_c('span',[_vm._v(_vm._s(pos.position_name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }